const EastTimorSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111345)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FFDA44"
      />
      <path
        d="M20.0003 0C15.1037 0 10.6188 1.7607 7.14209 4.68234L28.6959 20L7.14209 35.3177C10.6188 38.2393 15.1037 40 20.0003 40C31.0459 40 40.0003 31.0456 40.0003 20C40.0003 8.95437 31.0459 0 20.0003 0Z"
        fill="#D80027"
      />
      <path
        d="M5.85785 5.85742C-1.95262 13.6679 -1.95262 26.3312 5.85785 34.1418C9.08543 30.9142 12.1896 27.8101 20 19.9996L5.85785 5.85742Z"
        fill="black"
      />
      <path
        d="M5.54514 15.4189L8.58889 18.2996L12.2692 16.2946L10.4704 20.0797L13.5142 22.9604L9.35842 22.4192L7.55936 26.2043L6.79006 22.0846L2.63428 21.5432L6.31443 19.5384L5.54514 15.4189Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111345">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default EastTimorSvg;
